import {observer} from 'mobx-react'
import React from 'react'
import {FlatList, RefreshControl, View} from 'react-native'
import {
  FooterBar,
  FooterBarButton,
  FooterBarIconButton,
  ImageCard,
  ImageTextCard,
  ToprScreenLoader,
} from '../../../../Components'
import {navigate} from '../../../../Helpers/NavigationHelper'
import {GetFileUrl, GetRandomKey} from '../../../../Helpers/UiHelpers'
import I18n from '../../../../i18n'
import Style from '../../../../Style'
import {dashboardStore} from '../../Dashboard/Store'
import {dashboardHeaderStore} from '../DashboardHeader/Store'
import {LastItem} from '../../../../Helpers/ArrayHelpers'
interface IProps {}

const SavingCardsTab: React.FC<IProps> = ({children}) => {
  const {IsSavingcardsLoading, UserSavingCards} = dashboardStore
  const {defaultFlatList, flatListContentStyle} = Style
  return (
    <ToprScreenLoader isLoading={IsSavingcardsLoading}>
      <FlatList
        ListEmptyComponent={
          <ImageCard
            imageUrl="https://images.unsplash.com/photo-1565165928601-867958a20fdd?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
            text={I18n.t('Dashboard.NoSavingCards')}
          />
        }
        bounces={false}
        onScroll={(event) => {
          dashboardHeaderStore.SetScrollY(event.nativeEvent.contentOffset.y)
        }}
        style={[
          defaultFlatList,
          {paddingTop: dashboardHeaderStore.HEADER_MAX_HEIGHT * 2},
        ]}
        refreshControl={
          <RefreshControl
            refreshing={IsSavingcardsLoading}
            progressViewOffset={dashboardHeaderStore.HEADER_MAX_HEIGHT * 2}
            onRefresh={() => {
              dashboardStore.GetUserSavingCards()
            }}
          />
        }
        contentContainerStyle={[flatListContentStyle]}
        data={UserSavingCards}
        renderItem={({item}) => {
          const lastItem = LastItem(UserSavingCards)
          return (
            <ImageTextCard
              isLast={lastItem?.UserSavingCardGuid === item.UserSavingCardGuid}
              key={item.UserSavingCardGuid}
              imageUrl={GetFileUrl(item.SavingCard.ImageGuid)}
              title={item.SavingCard.Title}
              onPress={() => {
                navigate('savingCardDetails', {
                  userSavingCardGuid: item.UserSavingCardGuid,
                })
              }}
              badgeText={`${item.StampCount}/${item.SavingCard.StampCount}`}
            />
          )
        }}
        keyExtractor={() => {
          return GetRandomKey()
        }}
      />
      <FooterBar>
        <FooterBarIconButton
          icon={{name: 'qrcode', type: 'font-awesome'}}
          text={I18n.t('Common.Stamp')}
          onPress={() => navigate('qrCode')}
        />
        <FooterBarButton
          icon={{name: 'table', type: 'antdesign'}}
          text={I18n.t('Common.Summary')}
          onPress={() => {
            navigate('savingCardsSummary')
          }}
        />
      </FooterBar>
    </ToprScreenLoader>
  )
}

export default observer(SavingCardsTab)
